import { useCallback, useRef, useState } from "react"

const areSamePos = (posArray1, posArray2) => {
  return [0, 1, 2, 3].every((index) => posArray1[index] == posArray2[index]);
}

const comparePos = (posArray1, posArray2) => {
  for (const index of [0, 1, 2, 3]) {
    if (posArray1[index] !== posArray2[index]) {
      return Math.sign(posArray1[index] - posArray2[index]);
    }
  }
    
  return 0;
}

const findPosArrayTop = (posArray, componentsMap) => {
  return componentsMap.keys()
              .filter((pos) => (
                  !posArray || (pos[1] == posArray[1] && pos[3] == posArray[3])
                )
              )
              .toArray()
              .sort(comparePos)
              [0];
}

const findPosArrayLast = (posArray, componentsMap) => {
  return componentsMap.keys()
              .filter((pos) => (
                  !posArray || (pos[1] == posArray[1] && pos[3] == posArray[3])
                )
              )
              .toArray()
              .sort((pos1, pos2) => comparePos(pos2, pos1))
              [0];
}

const findPosArrayAbove = (posArray, componentsMap) => {
  const aboves = componentsMap.keys()
                  .filter(pos => (
                      pos[1] == posArray[1] && pos[3] == posArray[3]
                        && comparePos(pos, posArray) < 0
                    )
                  )
                  .toArray()
                  .sort((pos1, pos2) => comparePos(pos2, pos1))

  if (aboves.length > 0) {
    return aboves[0]
  } 
  return null;  
}

const findPosArrayBelow = (posArray, componentsMap) => {
  const belows = componentsMap.keys()
                  .filter((pos) => (
                      pos[1] == posArray[1] && pos[3] == posArray[3]
                        && comparePos(pos, posArray) > 0
                    )
                  )
                  .toArray()
                  .sort(comparePos)
  if (belows.length > 0) {
    return belows[0];
  } 

  return null;  
}

const findPosArrayLeft = (posArray, componentsMap) => {
  const lefts = componentsMap.keys()
                  .filter((pos) => (
                      comparePos(pos, posArray) < 0
                    )
                  )
                  .toArray()
                  .sort((pos1, pos2) => comparePos(pos2, pos1))
  if (lefts.length > 0) {
    return lefts[0]
  } 

  return null;  
}


const findPosArrayRight = (posArray, componentsMap) => {
  const rights = componentsMap.keys()
                  .filter((pos) => (
                      comparePos(pos, posArray) > 0
                    )
                  )
                  .toArray()
                  .sort(comparePos)
  if (rights.length > 0) {
    return rights[0];
  } 
  
  return null;  
}

export const useSupplyFormKeyHandler = (page, maxPage, movePage) => {

  const componentsMapRef = useRef(new Map());

  const updateComponent = useCallback((component, posArray) => {
    const key = componentsMapRef.current.keys().find(pos => areSamePos(pos, posArray));
    componentsMapRef.current.set(
      key || posArray,
      component
    );
  }, [componentsMapRef]);

  const deleteComponent = (posArray) => {
    const pos = componentsMapRef.current.keys()
      .find((pos) => areSamePos(pos, posArray))
    componentsMapRef.current.delete(pos);
  }

  const handleKeyDown = (posArray) => (e) => {

    if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(e.key)) {
      return;
    }

    e.preventDefault();
    let posToFocus = null;

    if (
      e.key === 'ArrowUp'
        || (e.shiftKey && e.key === 'Enter')
    ) {
      posToFocus = findPosArrayAbove(posArray, componentsMapRef.current);
      if (!posToFocus && page > 1) {
        e.target.blur();
        movePage(page - 1);
        posToFocus = findPosArrayLast(posArray, componentsMapRef.current);
      }

    }
    if (
      e.key === 'ArrowDown'
        || (!e.shiftKey && e.key === 'Enter')
    ) {
      posToFocus = findPosArrayBelow(posArray, componentsMapRef.current);
      if (!posToFocus && page < maxPage) {
        e.target.blur();
        movePage(page + 1);
        posToFocus = findPosArrayTop(posArray, componentsMapRef.current);
      }
    }
    if (e.key === 'ArrowLeft') {
      posToFocus = findPosArrayLeft(posArray, componentsMapRef.current);
      if (!posToFocus && page > 1) {
        e.target.blur();
        movePage(page - 1);
        posToFocus = findPosArrayLast(null, componentsMapRef.current);
      }

    }
    if (e.key === 'ArrowRight') {
      
      posToFocus = findPosArrayRight(posArray, componentsMapRef.current);
      if (!posToFocus && page < maxPage) {
        e.target.blur();
        movePage(page + 1);
        posToFocus = findPosArrayTop(null, componentsMapRef.current);
      }
    }

    if (posToFocus) {
      componentsMapRef.current.get(posToFocus)
        .children[0].focus();
    }
  }



  return (rowIndex) => (shopIndex) => ({
    registerComponent: (detailIndex, pos) => ({
      ref: (component) => {
          if (component) {
            updateComponent(component, [rowIndex, shopIndex, detailIndex, pos]);
          } else {
            deleteComponent([rowIndex, shopIndex, detailIndex, pos])
          }
      },
      onKeyDown: handleKeyDown([rowIndex, shopIndex, detailIndex, pos])
    }),
    deleteComponent
  })
}
